import React, { useRef, useState, useEffect } from 'react';
import { unit } from 'mathjs';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * @param {*} props
 * --- color
 * --- width
 * --- icon
 * --- title
 * --- stat
 * --- className
 */

var FeedBox = function FeedBox(props) {
  var color = props.color,
      width = props.width,
      icon = props.icon,
      title = props.title,
      stat = props.stat,
      className = props.className;
  var ref = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showIcon = _useState2[0],
      setShowIcon = _useState2[1];

  useEffect(function () {
    setShowIcon(ref.current.getBoundingClientRect().width > 125);

    var handleResize = function handleResize() {
      if (ref.current) {
        setShowIcon(ref.current.getBoundingClientRect().width > 125);
      }
    };

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return React.createElement("div", {
    ref: ref,
    className: "py-1 my-2 mx-2 px-2 d-flex align-items-center" + className,
    style: {
      color: color,
      borderRadius: "1rem",
      border: "1px solid " + color,
      width: width || "100%",
      maxWidth: "160px",
      backgroundColor: "#FFFFFF",
      zIndex: 5
    }
  }, React.createElement("div", {
    className: "d-flex flex-row py-2 align-items-center justify-content-center overflow-hidden"
  }, showIcon && icon, React.createElement("div", {
    className: "ml-2"
  }, React.createElement("div", {
    className: "font-weight-bold h6 paragraph-small mb-0"
  }, stat), React.createElement("div", {
    className: "paragraph-tiny"
  }, title))));
};

var CO2Saved = function CO2Saved(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["", className].join(" ");
  return React.createElement("svg", _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100;"
    },
    xmlSpace: "preserve"
  }, otherProps, {
    className: classNames,
    style: {
      minWidth: "2.5rem",
      minHeight: "2.5rem",
      maxWidth: "3rem",
      maxHeight: "3rem",
      fill: props.color
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M98,50c0,12.6-4.9,24.1-12.9,32.7L73.1,71 H80c9.3,0,10.9-5.5,10.9-5.7c2.7-8.2-0.3-13.6-3.4-16.6c-2.2-2.2-4.8-3.6-6.2-4.2c0.8-1.8,2.1-5.5,0.8-9.7 c-1.4-4.5-5.4-8.1-11.8-10.7c-5.6-2.3-10.8-2.5-15.4-0.6c-6.3,2.6-9.6,8.4-10.6,10.5c-3.3-0.3-5.9,0.4-7.9,1.5L16.3,15.9 C25,7.3,36.9,2,50,2C76.5,2,98,23.5,98,50z M36.1,37.9l13.3,12.9c-0.4,1.3-0.6,2.7-0.6,4.2c0,6.1,3.6,11,8,11c2,0,3.9-1.1,5.3-2.8 l6,5.8H25c-0.4,0-9-0.1-9-9c0-7.2,3.6-11.8,6.9-13.7c1.3-0.8,2.7-1.1,3.9-1.1c1,0,1.9,0.2,2.7,0.7c0.3,0.2,0.6,0.2,0.9,0.1 c0.3-0.1,0.5-0.4,0.6-0.7C31,45,32.3,40.6,36.1,37.9z M61.8,60.1l-10.1-9.8c1.1-2.6,3-4.3,5.1-4.3c3.3,0,6,4,6,9 C62.8,56.9,62.4,58.6,61.8,60.1z M60.7,61.8c-1.1,1.4-2.4,2.2-3.9,2.2c-3.3,0-6-4-6-9c0-0.9,0.1-1.8,0.3-2.6L60.7,61.8z M63.3,61.5 c1-1.8,1.6-4.1,1.6-6.5c0-6.1-3.6-11-8-11c-2.7,0-5.2,1.9-6.6,4.8L37.9,36.9c1.8-0.8,4.1-1.3,6.9-0.9c0.5,0.1,0.9-0.2,1.1-0.6 c0-0.1,3-7.3,9.8-10.1c4.1-1.7,8.8-1.5,13.9,0.6c5.8,2.4,9.4,5.6,10.6,9.5c1.5,4.8-1.1,9-1.1,9.1C79,44.7,79,45,79.1,45.3 c0.1,0.3,0.3,0.5,0.6,0.6c0,0,3.6,1.2,6.5,4.1C90,53.9,91,58.9,89,64.7C89,64.9,87.7,69,80,69h-9L63.3,61.5z M2,50 c0-12.6,4.9-24.1,12.9-32.7l19.8,19.2c-3,2.3-4.6,5.4-5.3,7.1c-2.3-0.8-5-0.5-7.6,0.9C18.1,46.7,14,51.9,14,60 c0,10.9,10.9,11,11,11h45.2l13.5,13.1C75,92.7,63.1,98,50,98C23.5,98,2,76.5,2,50z"
  }), React.createElement("path", {
    d: "M38.1,66c2.7,0,7.9-1.3,7.9-6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,3.9-5.7,4-5.9,4c-0.3,0-7.1-0.1-7.1-9 c0-8.8,6.2-9,6.5-9c0.1,0,6.5,0,6.5,4c0,0.6,0.4,1,1,1s1-0.4,1-1c0-4.7-5.6-6-8.5-6c-0.1,0-8.5,0.1-8.5,11S38,66,38.1,66z"
  }), React.createElement("path", {
    d: "M72.8,47.4h-3.1c0.3-0.3,0.7-0.6,1-0.9c0.3-0.3,0.6-0.6,0.9-1c0.2-0.2,0.4-0.5,0.6-0.7 c0.2-0.2,0.4-0.5,0.5-0.7c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.3,0.1-0.6,0.1-1c0-0.5-0.1-0.9-0.2-1.2c-0.1-0.3-0.4-0.6-0.6-0.8 c-0.3-0.2-0.6-0.4-1-0.5c-0.4-0.1-0.8-0.2-1.2-0.2c-0.4,0-0.7,0-1.1,0.1c-0.3,0.1-0.6,0.2-0.8,0.3c-0.2,0.1-0.4,0.3-0.6,0.4 c-0.2,0.2-0.3,0.3-0.4,0.5c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.5,0.2,0.6c0.2,0.1,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.3-0.3,0.4-0.5c0.2-0.2,0.4-0.4,0.6-0.5c0.2-0.1,0.5-0.2,0.8-0.2c0.4,0,0.7,0.1,1,0.3 c0.2,0.2,0.3,0.6,0.3,1c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.1,0.4-0.3,0.6s-0.3,0.4-0.5,0.6c-0.2,0.2-0.4,0.5-0.7,0.8 c-0.3,0.4-0.7,0.7-1.1,1.1c-0.4,0.4-0.8,0.7-1.2,1.2c-0.4,0.4-0.6,0.7-0.6,1c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h4.9 c0.3,0,0.5-0.1,0.6-0.2c0.1-0.2,0.2-0.3,0.2-0.6C73.4,47.7,73.2,47.4,72.8,47.4z"
  })));
};

var GridConsumption = function GridConsumption(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["", className].join(" ");
  return React.createElement("svg", _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100;"
    },
    xmlSpace: "preserve"
  }, otherProps, {
    className: classNames,
    style: {
      minWidth: "2.5rem",
      minHeight: "2.5rem",
      maxWidth: "3rem",
      maxHeight: "3rem",
      fill: props.color
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M96,41h3c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1h4v8H66V37.3l29.5-16.4 c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0,0,0,0,0,0c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0,0v-9h3 c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1h4v8H65.6L56.7,2H69v8c0,0.6,0.4,1,1,1s1-0.4,1-1V1c0-0.6-0.4-1-1-1H55 H45H30c-0.6,0-1,0.4-1,1v9c0,0.6,0.4,1,1,1s1-0.4,1-1V2h12.3l-8.9,17H6v-8h4c0.6,0,1-0.4,1-1s-0.4-1-1-1H1c-0.6,0-1,0.4-1,1 s0.4,1,1,1h3v9c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1 L34,37.3V49H6v-8h4c0.6,0,1-0.4,1-1s-0.4-1-1-1H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h3v9c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.4 c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1l29.4,19.6L24.3,98H1c-0.6,0-1,0.4-1,1s0.4,1,1,1 h98c0.6,0,1-0.4,1-1s-0.4-1-1-1H75.7l-9.5-27.6l29.4-19.6c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2 c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.2,0.1-0.4c0,0,0,0,0,0V41z M50,78.8l-14-9.3V50.7l14-4.7l14,4.7v18.7L50,78.8z M64,21v15.1l-14,7.8 l-14-7.8V21H64z M64,48.6l-11.5-3.8L64,38.4V48.6z M66,35V21h25.1L66,35z M45.6,2h8.8l8.9,17H36.7L45.6,2z M8.9,21H34v14L8.9,21z M47.5,44.8L36,48.6V38.4L47.5,44.8z M34,51v17.1L8.3,51H34z M35.5,71.6l12.8,8.5L27,96.2L35.5,71.6z M28,98l22-16.7L72,98H28z M73,96.2L51.7,80.1l12.8-8.5L73,96.2z M66,68.1V51h25.7L66,68.1z"
  })));
};

/**
 * Mass Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in g
 */

var determineBestUnit = function determineBestUnit(value) {
  // let units = ["g", "kg", "tonne", "kilotonne", "megatonne", "gigatonne"];
  var units = ["g", "kg", "tonne", "ktonne", "mtonne", "Gtonne"];
  var converted = units.map(function (u) {
    return {
      unit: u,
      value: unit(value, "g").to(u).toNumber()
    };
  });

  var _ref = converted.filter(function (e) {
    return e.value > 1 && e.value < 1000;
  })[0] || {},
      unit$1 = _ref.unit;

  return unit$1 ? unit$1 : "g";
};
/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in g
 */

var autoFormatMassValue = function autoFormatMassValue(value) {
  var unit$1 = determineBestUnit(value);
  var num = unit(value, "g").to(unit$1).toJSON();
  return "".concat(parseFloat(num.value).toFixed(2).toLocaleString(), "  ").concat(num.unit);
};

/**
 * Energy Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in wh
 */

var determineBestUnit$1 = function determineBestUnit(value) {
  var units = ["Wh", "kWh", "MWh", "GWh", "TWh"];
  var converted = units.map(function (u) {
    return {
      unit: u,
      value: unit(value, "Wh").to(u).toNumber()
    };
  });

  var _ref = converted.filter(function (e) {
    return e.value > 1 && e.value < 1000;
  })[0] || {},
      unit$1 = _ref.unit;

  return unit$1 ? unit$1 : "kWh";
};
/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in wh
 */

var autoFormatEnergyValue = function autoFormatEnergyValue(value) {
  var unit$1 = determineBestUnit$1(value);
  var num = unit(value, "Wh").to(unit$1).toJSON();
  return "".concat(parseFloat(num.value).toFixed(2).toLocaleString(), "  ").concat(num.unit);
};

var SolarCapacity = function SolarCapacity(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["", className].join(" ");
  return React.createElement("svg", _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100;"
    },
    xmlSpace: "preserve"
  }, otherProps, {
    className: classNames,
    style: {
      minWidth: "2.5rem",
      minHeight: "2.5rem",
      maxWidth: "3rem",
      maxHeight: "3rem",
      fill: props.color
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M41,26c0-8.8-7.2-16-16-16S9,17.2,9,26s7.2,16,16,16S41,34.8,41,26z M11,26c0-7.7,6.3-14,14-14s14,6.3,14,14 s-6.3,14-14,14S11,33.7,11,26z"
  }), React.createElement("path", {
    d: "M25,7c0.6,0,1-0.4,1-1V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v5C24,6.6,24.4,7,25,7z"
  }), React.createElement("path", {
    d: "M43,26c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1s-0.4-1-1-1h-5C43.4,25,43,25.4,43,26z"
  }), React.createElement("path", {
    d: "M7,26c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h5C6.6,27,7,26.6,7,26z"
  }), React.createElement("path", {
    d: "M9.3,11.7C9.5,11.9,9.7,12,10,12s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-5-5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4 L9.3,11.7z"
  }), React.createElement("path", {
    d: "M45.7,46.7c0.4-0.4,0.4-1,0-1.4l-5-5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l5,5c0.2,0.2,0.5,0.3,0.7,0.3 S45.5,46.9,45.7,46.7z"
  }), React.createElement("path", {
    d: "M40,12c0.3,0,0.5-0.1,0.7-0.3l5-5c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-5,5c-0.4,0.4-0.4,1,0,1.4 C39.5,11.9,39.7,12,40,12z"
  }), React.createElement("path", {
    d: "M9.3,40.3l-5,5c-0.4,0.4-0.4,1,0,1.4C4.5,46.9,4.7,47,5,47s0.5-0.1,0.7-0.3l5-5c0.4-0.4,0.4-1,0-1.4 S9.7,39.9,9.3,40.3z"
  }), React.createElement("path", {
    d: "M40,94H30c-3.9,0-4-3.6-4-4V45c0-0.6-0.4-1-1-1s-1,0.4-1,1v45c0,2.1,1.3,6,6,6h10c0.6,0,1-0.4,1-1 S40.6,94,40,94z"
  }), React.createElement("path", {
    d: "M99,29h-3.2H91v-9c0-0.6-0.4-1-1-1s-1,0.4-1,1v9h-8v-9c0-0.6-0.4-1-1-1s-1,0.4-1,1v9h-4.8H70c-0.6,0-1,0.4-1,1 s0.4,1,1,1h3.9c-0.5,3.8-1.5,15.7,3.5,21.6c1.7,2,3.9,3.1,6.6,3.3v34c0,0.2,0,4-4,4H70c-0.6,0-1,0.4-1,1s0.4,1,1,1h10 c4.7,0,6-3.9,6-6V56c2.7-0.2,4.9-1.3,6.6-3.3c5-5.9,4-17.8,3.5-21.6H99c0.6,0,1-0.4,1-1S99.6,29,99,29z M91.1,51.3 C89.6,53.1,87.6,54,85,54c-2.6,0-4.6-0.9-6.1-2.7c-4.6-5.4-3.4-17.1-3-20.3h18.3C94.5,34.2,95.7,45.9,91.1,51.3z"
  }), React.createElement("path", {
    d: "M60.9,89.1c-0.5-0.3-1.1-0.1-1.4,0.4l-4.1,7.4l-4.1-7.4c-0.4-0.6-1.4-0.6-1.7,0l-5,9c-0.3,0.5-0.1,1.1,0.4,1.4 c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.2,0.9-0.5l4.1-7.4l4.1,7.4c0.4,0.6,1.4,0.6,1.7,0l5-9C61.6,90,61.4,89.4,60.9,89.1z"
  })));
};

var SolarGeneration = function SolarGeneration(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["", className].join(" ");
  return React.createElement("svg", _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100;"
    },
    xmlSpace: "preserve"
  }, otherProps, {
    className: classNames,
    style: {
      minWidth: "2.5rem",
      minHeight: "2.5rem",
      maxWidth: "3rem",
      maxHeight: "3rem",
      fill: props.color
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M99.8,75.5c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0l-13-28c0.1-0.8,0.5-1.3,1-1.6c1.8-1,5.4,0.4,6.7,1c0.4,0.2,1,0.1,1.2-0.3c0.3-0.4,0.2-0.9-0.1-1.3 c-2.7-2.8-3.9-5.3-3.3-7.5c1-3.9,6.8-5.8,6.9-5.8c0.4-0.1,0.7-0.5,0.7-1c0-0.4-0.3-0.8-0.8-0.9c-4.2-1-6.7-2.7-7.3-4.8 c-1-3.8,3.7-8.4,3.7-8.5c0.3-0.3,0.4-0.8,0.2-1.2c-0.2-0.4-0.7-0.6-1.1-0.5c-4.3,0.9-7.3,0.5-8.7-1.1c-2.1-2.5-0.2-7.5-0.2-7.5 c0.2-0.4,0-1-0.4-1.2c-0.4-0.3-0.9-0.2-1.3,0.2c-2.8,3-5.3,4.2-7.4,3.7C72.9,7.1,71,0.8,71,0.7c-0.1-0.4-0.5-0.7-1-0.7 c-0.5,0-0.8,0.4-0.9,0.8c-0.7,3.7-2.1,5.9-4.1,6.6c-3.9,1.4-9.2-3.2-9.3-3.2c-0.3-0.3-0.8-0.3-1.2-0.1c-0.4,0.2-0.6,0.6-0.5,1.1 c0.8,4.3,0.4,7.2-1.3,8.6c-2.5,2.1-7.3,0.3-7.3,0.3c-0.4-0.2-0.9,0-1.2,0.4c-0.3,0.4-0.2,0.9,0.1,1.2c3.1,3.3,4.2,6.1,3.5,8.3 c-1.2,3.8-7.5,5-7.6,5c-0.5,0.1-0.9,0.6-0.8,1.1c0.1,0.8,0.8,0.9,2.1,1.2c1.6,0.4,4.6,1,6.1,2.6H20.4c-0.4,0-0.7,0.2-0.9,0.6 l-19.4,40c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1 c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0h38v22H25c-0.6,0-1,0.4-1,1s0.4,1,1,1h50c0.6,0,1-0.4,1-1s-0.4-1-1-1H61V76h38c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.3,0,0.4-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1 C99.8,75.6,99.8,75.6,99.8,75.5z M76.2,74l-3.2-13H91c0.1,0,0.2,0,0.4-0.1L97.4,74H76.2z M60,74h-8.6V61h19.5l3.2,13H60z M40,74 H26.7l3.2-13h19.5v13H40z M2.6,74l6.3-13c0,0,0.1,0,0.1,0h18.9l-3.2,13H2.6z M16.2,46h15.4l-3.2,13H9.9L16.2,46z M49.4,36v8H34.2 l2-8H49.4z M64.6,36l2,8H51.4v-8H64.6z M69.2,46h15.2l6,13h-18L69.2,46z M70.4,59h-19V46h15.7L70.4,59z M68.7,44l-2-8h13.1l3.7,8 H68.7z M49.4,46v13h-19l3.2-13H49.4z M44,29.9c2.2-0.9,4.8-2.6,5.7-5.3c0.8-2.4,0.1-5-2-8c1.9,0.3,4.4,0.2,6.3-1.4 c1.9-1.6,2.7-4.3,2.4-8.1c2.2,1.4,6,3.3,9.2,2.1c2.1-0.7,3.6-2.5,4.6-5.2c1.1,2.2,3.1,5.1,6.2,5.8c2.2,0.5,4.5-0.2,6.9-2 c-0.3,2-0.1,4.4,1.4,6.2c1.5,1.8,4.2,2.6,7.9,2.2c-1.5,2-3.3,5.2-2.4,8.3c0.6,2.4,2.7,4.2,6.1,5.5c-2.1,1.1-4.9,3.1-5.6,6.1 c-0.5,2.1,0,4.3,1.5,6.6c-1.7-0.4-3.6-0.5-5.1,0.3c-0.4,0.2-0.8,0.5-1.1,1l-4.5-9.6c-0.2-0.4-0.5-0.6-0.9-0.6H50 C48.9,31.7,46.2,30.6,44,29.9z M21,36h13.1l-2,8h-15L21,36z M59,98H41V76h18V98z"
  })));
};

var CO2Emitted = function CO2Emitted(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var classNames = ["", className].join(" ");
  return React.createElement("svg", _extends({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100;"
    },
    xmlSpace: "preserve"
  }, otherProps, {
    className: classNames,
    style: {
      minWidth: "2.5rem",
      minHeight: "2.5rem",
      maxWidth: "3rem",
      maxHeight: "3rem",
      fill: props.color
    }
  }), React.createElement("g", null, React.createElement("path", {
    d: "M86.2,47.45c1.01-2.08,2.87-7.02,1.1-12.55c-1.81-5.68-6.86-10.27-15.02-13.65c-7.18-2.97-13.79-3.24-19.66-0.79 c-8.26,3.45-12.44,11.15-13.56,13.53c-12.76-1.27-17.92,9.08-19.29,12.57c-2.89-1.19-6.45-0.81-9.76,1.08 C5.17,50.42,0,57.03,0,67.3c0,13.73,13.75,13.89,13.89,13.89h70.9c11.82,0,13.78-6.9,13.84-7.13 C104.39,56.78,90.33,49.24,86.2,47.45z M96.72,73.48c-0.07,0.23-1.74,5.71-11.93,5.71h-70.9C13.41,79.19,2,79.06,2,67.3 c0-9.41,4.65-15.42,9-17.91c1.76-1.01,3.54-1.52,5.2-1.52c1.31,0,2.54,0.32,3.62,0.95c0.27,0.16,0.59,0.18,0.88,0.07 c0.29-0.12,0.51-0.36,0.59-0.66c0.16-0.57,4.09-14.04,18.24-12.17c0.45,0.06,0.88-0.19,1.06-0.61c0.04-0.09,3.96-9.46,12.81-13.15 c5.36-2.23,11.45-1.96,18.11,0.8c7.57,3.14,12.24,7.31,13.87,12.38c2.01,6.28-1.41,11.89-1.45,11.95c-0.16,0.26-0.2,0.58-0.09,0.87 c0.1,0.29,0.33,0.51,0.62,0.61c0.05,0.02,4.71,1.61,8.52,5.45C98.01,59.41,99.27,65.82,96.72,73.48z"
  }), React.createElement("path", {
    d: "M54.9,46.96c-5.54,0-10.05,6.23-10.05,13.89c0,7.66,4.51,13.89,10.05,13.89s10.05-6.23,10.05-13.89 C64.94,53.19,60.44,46.96,54.9,46.96z M54.9,72.75c-4.44,0-8.05-5.33-8.05-11.89s3.61-11.89,8.05-11.89s8.05,5.33,8.05,11.89 S59.33,72.75,54.9,72.75z"
  }), React.createElement("path", {
    d: "M76.65,46.24c-1.78-0.8-3.85-0.42-5.42,0.98c-0.41,0.37-0.45,1-0.08,1.41c0.37,0.41,1,0.45,1.41,0.08 c0.97-0.87,2.22-1.11,3.27-0.65c0.95,0.42,1.51,1.35,1.51,2.48v1.29c0,1.33-1.34,2.04-3.54,3.06c-0.83,0.38-1.68,0.77-2.44,1.25 c-0.29,0.18-0.47,0.5-0.47,0.85v3.87c0,0.55,0.45,1,1,1h6.45c0.55,0,1-0.45,1-1s-0.45-1-1-1H72.9v-2.3 c0.54-0.3,1.15-0.58,1.74-0.85c2.21-1.02,4.71-2.17,4.71-4.88v-1.29C79.35,48.63,78.31,46.98,76.65,46.24z"
  }), React.createElement("path", {
    d: "M30,48.96c0.09,0,8.67,0.08,8.67,5.45c0,0.55,0.45,1,1,1s1-0.45,1-1c0-5.89-6.98-7.45-10.67-7.45 c-0.11,0-10.67,0.16-10.67,13.89s11.33,13.89,11.45,13.89c3.42,0,9.89-1.56,9.89-7.45c0-0.55-0.45-1-1-1s-1,0.45-1,1 c0,5.36-7.57,5.45-7.89,5.45c-0.39,0-9.45-0.13-9.45-11.89C21.34,49.17,29.66,48.97,30,48.96z"
  })));
};

/**
 * This component displays the feed totals for the given data.
 * There are two primary ways to achieve this:
 *
 * First: The component can take react components (such as FeedBoxes)
 * as children, and they will be displayed
 *
 * Second: The component takes data in the form its given in the API (data.totals)
 * and then builds the boxes/displays them
 *
 * @param props can be in the form of a "data" object or child components
 */

var FeedTotals = function FeedTotals(_ref) {
  var children = _ref.children,
      vertical = _ref.vertical,
      data = _ref.data,
      hasCapacity = _ref.hasCapacity,
      hasBackdrop = _ref.hasBackdrop,
      fixed = _ref.fixed;
  var iconWidth = "20%";
  var solarCapacityColor = "#EB7624";
  var gridConsumedColor = "#5e5d63";
  var solarGeneratedColor = "green";
  var co2EmittedColor = "black";
  var co2AvoidedColor = "#95DD19";
  var verticalBackdropColor = "lightgray";

  if (!data) {
    data = {};
  }

  var formatMass = function formatMass(mass) {
    return typeof mass === "number" ? autoFormatMassValue(mass) : "N/A";
  };

  var formatEnergy = function formatEnergy(energy) {
    return typeof energy === "number" ? autoFormatEnergyValue(energy) : "N/A";
  }; // optional solarcapacity -- adds more flexibility for data with more than one pv


  var solarCapacityEl = hasCapacity && React.createElement(FeedBox, {
    key: 1,
    title: "Solar Capacity",
    color: solarCapacityColor,
    icon: React.createElement(SolarGeneration, {
      fill: solarCapacityColor,
      width: iconWidth
    }),
    stat: formatEnergy(data.solarCapacity) === "N/A" ? "N/A" : "".concat(formatEnergy(data.solarCapacity).substr(0, formatEnergy(data.solarCapacity).length - 1), "p")
  }); // defaults

  var components = [solarCapacityEl, React.createElement(FeedBox, {
    key: 2,
    title: "Grid Consumed",
    color: gridConsumedColor,
    icon: React.createElement(GridConsumption, {
      fill: gridConsumedColor,
      width: iconWidth
    }),
    stat: formatEnergy(data.gridConsumed)
  }), React.createElement(FeedBox, {
    key: 3,
    title: "Solar Generated",
    color: solarGeneratedColor,
    icon: React.createElement(SolarCapacity, {
      fill: solarGeneratedColor,
      width: iconWidth
    }),
    stat: formatEnergy(data.solarGenerated)
  }), React.createElement(FeedBox, {
    key: 4,
    title: "CO2 Emitted",
    color: co2EmittedColor,
    icon: React.createElement(CO2Emitted, {
      fill: co2EmittedColor,
      width: iconWidth
    }),
    stat: formatMass(data.co2Produced)
  }), React.createElement(FeedBox, {
    key: 5,
    title: "CO2 Avoided",
    color: co2AvoidedColor,
    icon: React.createElement(CO2Saved, {
      fill: co2AvoidedColor,
      width: iconWidth
    }),
    stat: formatMass(data.co2Saved)
  })];
  return React.createElement("div", {
    className: "d-flex align-".concat(vertical ? "items" : "content", "-center ").concat(vertical ? "align" : "justify", "-content-around ").concat(vertical && "position-relative flex-column"),
    style: fixed && {
      width: "160px"
    }
  }, vertical && hasBackdrop && React.createElement("div", {
    style: {
      backgroundColor: verticalBackdropColor,
      opacity: "0.5",
      borderRadius: "0.875rem",
      zIndex: "1"
    },
    className: "h-100 w-25 position-absolute"
  }), children ? children : components);
};

FeedTotals.defaultProps = {
  data: {},
  hasCapacity: false,
  hasBackdrop: false,
  vertical: false
};

export default FeedTotals;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/components/FeedTotals/index.js
// module id = 4bBf
// module chunks = 3